export const index = {
  "ChineseSite" : "中国站",
  "LogIn" : "登录",

  "LeadingEnterprise" : "智慧工厂整体解决方案领军企业",
  "MakingWorld" : "CM工业互联网平台--打造中国服装、家纺行业数字化及智能制造新引擎",
  "CleverMax" : "Clever Max",
  "TheMostEfficient" : " — 效率最高的智能吊挂生产线",
  "TurningFirst" : "让一流的客户成为我们的客户，让我们的客户成为一流的企业",
  "ContactUsNow" : "立 即 咨 询",
  "AnInterconnected" : "万物互联的智能世界",
  "CleverMaxBrandStory" : "CleverMax品牌故事",
  "Expertsin" : "智慧工厂整体解决方案专家",
  "ExploreIndustrySolutions" : "了解行业解决方案",
  "free" : "免费体验",
  "BusinessPartnerships" : "企业合作伙伴",
  "YearsofCollaboration" : "合作年限",

  "IndustryPainPoints" : "行业痛点",
  "IndustryFeatures" : "行业特点",
  "RequestaDemo" : "申请演示",
  "Terms" : "项",
  "VoiceofCustomer" : "客户之声",
  "CustomerCases" : "客户案例",
  "ProductsApplied" : "使用产品",
  "Location" : "所在地区",
  "hot" : "热搜",
  "keyword" : "请输入您要查询的关键词",
  "Engineering" : "工程合作",




}



// WEBPACK FOOTER //
// ./src/lang/ch.js